import { statusService } from '../_services';

export const status = {
    namespaced: true,
    state: {
        all: []
    },
    actions: {
        getStatusCollection({ commit }) {
            commit('getAllRequest');

            statusService.getStatusCollection()
                .then(
                    status => commit('getAllSuccess', status),
                    error => commit('getAllFailure', error)
                );
        }
    },
    mutations: {
        getAllRequest(state) {
            state.all = { loading: true };
        },
        getAllSuccess(state, status) {
            state.all = status['hydra:member'];
        },
        getAllFailure(state, error) {
            state.all = { error };
        }
    },
    getters: {
        showStatusCollection(state) {
            return state.all;
        },
        getStatusByIRI: (state) => (iri) => {
            return state.all.find( status => status['@id'] === iri)
        },
        isLoading(state) {
            return (state.all.loading);
        }
    }
};
